module.exports = `${require.publicPath}407.ada969ea.png`;